import { MasterProduct } from '../types';
import { toLowerAndTrim } from './toLowerAndTrim';
import { MaxHeap } from '@datastructures-js/heap';
import * as levenshtein from 'fast-levenshtein';

type HeapElement = {
  distance: number;
  product: MasterProduct;
};

export const findMatches = (input: string, products: MasterProduct[], topN: number) => {
  const processedInput = toLowerAndTrim(input);

  const heap = new MaxHeap<HeapElement>((element) => element.distance);

  for (const product of products) {
    if (!product?.product_name) continue;
    const processedProduct = toLowerAndTrim(product.product_name);
    const distance = levenshtein.get(processedInput, processedProduct);
    const heapElement: HeapElement = { distance, product };

    if (heap.size() < topN) {
      heap.insert(heapElement);
    } else {
      const top = heap.top();
      if (top && distance < top.distance) {
        heap.pop();
        heap.insert(heapElement);
      }
    }
  }

  return heap
    .toArray()
    .sort((a, b) => a.distance - b.distance)
    .map((element) => element.product);
};
